import React from 'react';

export const CopyLinkIcon = ({
  width = 18,
  height = 18,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 5.25h-3v1.5h3A2.257 2.257 0 0 1 15 9a2.257 2.257 0 0 1-2.25 2.25h-3v1.5h3c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75Zm-4.5 6h-3A2.257 2.257 0 0 1 3 9a2.257 2.257 0 0 1 2.25-2.25h3v-1.5h-3C3.18 5.25 1.5 6.93 1.5 9c0 2.07 1.68 3.75 3.75 3.75h3v-1.5ZM6 8.25h6v1.5H6v-1.5Z"
      fill={color}
    />
  </svg>
);
